import { useMutation } from "@apollo/client";
import { useSession } from "contexts";
import { ForeflightAuthDocument, UpdateStripeConnectDocument } from "graphql/generated";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const ForeFlightCallback = () => {
    const urlParams = new URLSearchParams(window.location?.search);
    const code = urlParams?.get('code');    
    const navigate = useNavigate();
    const { organizationId } = useSession();
    const [ foreflightAuth ] = useMutation(ForeflightAuthDocument);
    useEffect(() => {
        if(code) {
            foreflightAuth({
                variables: {
                    code,
                    organizationId
                }
            }).then(() => {
                navigate('/account/settings?settingsTab=Integrations');
            });
        }
    }, [code]);
    return (
        <div className="p-10">
            <h1>Redirecting Back to App</h1>
        </div>
    );
}

export default ForeFlightCallback;
